<template>
  <div class="home">
    <div class="banner-box" id="home" ref="home">
      <menuBox :step="1"></menuBox>
      <div class="banner-text">
        <div class="title">Berenanglah di lautan Internet dan rasakan pengalaman berbelanja yang menyenangkan, platform perdagangan online dengan integritas dan hasil yang saling menguntungkan, semuanya ada di portal kami.</div>
        <div class="text">
          Di sini, Anda dapat memulai perjalanan ke pasar global dengan satu klik. Kami membantu Anda mengakses peluang bisnis global dengan mudah, memastikan kualitas, layanan yang utama, dan platform perdagangan online dengan integritas dan win-win sebagai intinya. Produk kami yang beragam akan memberi Anda pengalaman berbelanja yang tak tertandingi, memungkinkan Anda menikmati kenyamanan dan kejutan berbelanja.

        </div>
      </div>
    </div>
    <div class="plan-box">
      <!-- <div class="box-title">
        Kami bersedia untuk tumbuh bersama perusahaan
      </div> -->
      <div class="list">
        <div class="item">
          <img src="../assets/plan-1.png" alt="" />
          <div class="title">
            Pengalaman belanja dan perdagangan terpadu:
          </div>
          <div class="text">
            Platform kami tidak hanya menyediakan pilihan produk yang kaya dan beragam, namun juga mengintegrasikan alat dan layanan perdagangan yang efisien dan nyaman. Anda dapat menikmati berbelanja di sini sambil dengan mudah menangani detail rumit perdagangan internasional.
          </div>
        </div>
        <div class="item">
          <img src="../assets/plan-2.png" alt="" />
          <div class="title">
Jaminan kualitas dan pengalaman pengguna:
          </div>
          <div class="text">
            Kami berpusat pada pengguna dan berkomitmen untuk memberikan pengalaman berbelanja yang luar biasa dan layanan sempurna kepada setiap pelanggan. Baik itu jaminan kualitas produk atau kepuasan pelanggan, kami mengontrol secara ketat untuk memastikan bahwa setiap detail memenuhi standar tertinggi.
          </div>
        </div>
        <div class="item">
          <img src="../assets/plan-3.png" alt="" />
          <div class="title">
            Visi global dan perluasan pasar:
          </div>
          <div class="text">
            Melalui platform kami, Anda dapat dengan mudah menjangkau pasar global, menjajaki peluang bisnis baru, dan memperluas jangkauan internasional bisnis Anda. Strategi globalisasi dan layanan lokalisasi kami dapat membantu Anda membangun jaringan bisnis yang solid di seluruh dunia
          </div>
        </div>
      </div>
    </div>
    <div class="mission-box">
      <img src="../assets/mession.png" alt="" />
      <div class="content">
        <div class="title">
          Pengalaman berbelanja yang luar biasa, menghubungkan dunia, memimpin tren perdagangan baru di masa depan
        </div>
        <div class="text">
         
Kami bukan hanya sebuah platform Internet, tetapi juga pionir dengan kemungkinan tak terbatas. Di platform ini, Anda tidak hanya dapat menemukan produk dari seluruh dunia, tetapi juga menikmati pengalaman berbelanja yang nyaman dan layanan berkualitas tinggi. Pada saat yang sama, Anda juga dapat melakukan perdagangan global melalui kami dan memperluas wilayah bisnis Anda. Bergabunglah dengan kami untuk membuka pintu ke dunia baru dan bekerja sama untuk menciptakan nilai bisnis masa depan.
        </div>
        <div class="list">
          <p><img src="../assets/right-icon-1.png" alt="">
            Kemungkinan eksplorasi yang tak terbatas: Di platform kami, Anda akan merasakan peluang inovasi dan pengembangan yang tak tertandingi. Baik Anda mencari solusi teknologi terkini atau ingin menjajaki peluang bisnis di pasar negara berkembang, kami dapat memberi Anda dukungan dan layanan komprehensif.</p>
          <p><img src="../assets/right-icon-2.png" alt="">Berbasis inovasi dan berorientasi masa depan: Kami tidak hanya fokus pada kebutuhan dan tren saat ini, namun juga fokus pada pengembangan dan inovasi di masa depan. Melalui inovasi teknologi berkelanjutan dan wawasan pasar, kami membantu Anda tetap menjadi yang terdepan dalam industri yang sangat kompetitif.</p>
        </div>
      </div>

    </div>
    <div class="text-box">
      <div class="title">
        Produk yang beragam dan pengalaman berbelanja yang tak tertandingi menghadirkan kejutan dan kenyamanan bagi Anda.

      </div>
      <div class="text">
      
Jelajahi pilihan kami dan temukan lebih banyak kejutan! Baik itu pakaian fashion, peralatan rumah tangga, atau elektronik, kami memiliki beragam pilihan untuk memenuhi kebutuhan Anda. Klik untuk masuk ke halaman produk kami dan segera memulai perjalanan belanja Anda. Pada saat yang sama, kami adalah merek yang berfokus pada Internet, belanja, dan perdagangan, berkomitmen untuk mendorong transaksi yang efisien melalui konten berkualitas tinggi, dan berupaya memberikan pengalaman berbelanja terbaik kepada setiap pengguna.

      </div>
    </div>
    <div class="img-box">
      <img src="../assets/img-box-1.png" alt="" class="left">
      <div class="list">
        <img src="../assets/img-box-2.png" alt="">
        <img src="../assets/img-box-3.png" alt="">
        <img src="../assets/img-box-4.png" alt="">
        <img src="../assets/img-box-5.png" alt="">
      </div>
    </div>
    <div class="solutions-box">
      <div class="title">
        Buka pintu menuju dunia baru dan ciptakan nilai bisnis masa depan bersama kami.

      </div>
      <div class="banner-list">
        <div class="item">
          <img src="../assets/business-1.png" alt="" />
          <div class="title">
            Berbagai produk yang kaya
          </div>
          <div class="text">
            Pusat perbelanjaan online tidak memiliki batasan area bisnis seperti toko fisik dan dapat mencakup berbagai produk dalam dan luar negeri, yang sepenuhnya mewujudkan keunggulan Internet yang tidak memiliki lokasi geografis. Pengguna dapat memilih beragam produk secara online tanpa dibatasi ruang dan waktu.
          </div>
        </div>
        <div class="item">
          <img src="../assets/business-2.png" alt="" />
          <div class="title">
            Pengalaman layanan yang efisien
          </div>
          <div class="text">
            Pusat perbelanjaan online biasanya menyediakan layanan pelanggan yang sangat baik dan metode pembayaran yang aman untuk memastikan pengalaman berbelanja pengguna lebih lancar dan aman. Selain itu, website dapat merangkum permasalahan yang paling menjadi perhatian pelanggan dan memberikan jawaban untuk menyelesaikan pertanyaan pelanggan.
          </div>
        </div>
        <div class="item">
          <img src="../assets/business-3.png" alt="" />
          <div class="title">
            Konten informasi produk yang kaya
          </div>
          <div class="text">
            Mal online menyediakan banyak informasi produk, dan pengguna dapat sepenuhnya membandingkan dan memilih produk yang tidak tersedia secara lokal. Kekayaan informasi ini memungkinkan pengguna untuk membuat keputusan pembelian yang lebih tepat

          </div>
        </div>
      </div>
    </div>


    <footerBox></footerBox>
  </div>
</template>

<script>
  import footerBox from "@/components/footer";
  import menuBox from "@/components/menu";

  export default {
    name: "App",
    components: {
      menuBox,
      footerBox,
    },
    data() {
      return {};
    },
    mounted() { },
    methods: {},
  };
</script>

<style lang="less" scoped>
  .banner-box {
    background-image: url(../assets/swiper-1.png);
    height: 1020px;
    background-size: 100% 100%;

    .banner-text {
      text-align: left;
      width: 600px;
      margin-left: 360px;
      margin-top: 150px;

      .title {
        font-family: Roboto, Roboto;
        font-weight: 800;
        font-size: 36px;
        color: #333333;

        img {
          vertical-align: middle;
          width: 63px;
        }
      }

      .subtitle {
        font-size: 26px;
        font-weight: 500;
        color: #fff;
      }

      .text {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        margin-top: 20px;
      }
    }
  }

  .plan-box {
    padding: 100px 360px;


    .box-title {
      padding: 0 200px;
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 52px;
      color: #252B42;
      text-align: center;
    }

    .list {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 30px;

      .item {
        text-align: left;
        width: 361px;
        background: #FFFFFF;
        box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.1);
        border-radius: 0px 0px 32px 0px;
        height: 460px;

        img {
          width: 92px;
          height: 92px;
          margin-top: 50px;
          margin-left: 44px;
        }

        .title {
          font-family: HelveticaNeue, HelveticaNeue;
          font-weight: bold;
          font-size: 23px;
          color: #333333;
          margin: 17px 44px;
        }

        .text {
          font-family: HelveticaNeue;
          font-size: 16px;
          color: #999999;
          margin: 0px 44px;
        }
      }
    }
  }

  .solutions-box {
    padding: 100px 360px;
    background: #ECF1FA;

    .title {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 52px;
      color: #252B42;
      text-align: center;
    }

    .banner-list {
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
      margin-top: 100px;

      .item {

        img {
          width: 380px;
          height: 400px;
        }

        .title {
          font-family: HelveticaNeue, HelveticaNeue;
          font-weight: bold;
          font-size: 32px;
          color: #333333;
          width: 360px;
          padding-top: 25px;
          text-align: left;
        }

        .text {
          font-family: HelveticaNeue;
          font-size: 20px;
          color: #999999;
          width: 340px;
          border-radius: 0 0 20px 20px;
          text-align: left;
          margin-top: 20px;
        }
      }
    }
  }

  .text-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 100px 360px;

    .title {
      width: 517px;
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 40px;
      color: #252B42;
    }

    .text {
      width: 543px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 18px;
      color: #737373;
    }
  }

  .img-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 50px 150px;

    .left {
      width: 526px;
      height: 860px;
      margin-right: 20px;
    }

    .list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;

      img {
        width: 528px;
        height: 420px;
        margin-bottom: 20px;
      }

      img:nth-child(3) {
        margin-bottom: 0;
      }

      img:nth-child(4) {
        margin-bottom: 0;
      }
    }
  }

  .mission-box {
    padding: 50px 360px;
    padding-left: 0;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .content {
      width: 580px;

      .title {
        font-family: HelveticaNeue, HelveticaNeue;
        font-weight: bold;
        font-size: 40px;
        color: #333333;
        margin-bottom: 50px;
      }

      .text {
        font-family: HelveticaNeue;
        font-size: 18px;
        color: #333333;
      }

      .list {
        margin-top: 50px;

        p {
          font-family: HelveticaNeue;
          font-size: 16px;
          color: #333333;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
        }

        img {
          width: 92px;
          height: 92px;
          vertical-align: middle;
          margin-right: 40px;
        }
      }
    }

    img {
      width: 869px;
      height: 835px;
    }
  }

  .happy-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 100px 360px;
    background-color: #FEFBF6;

    .content {
      width: 580px;

      .title {
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 52px;
        color: #252B42;
      }

      .text {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        margin-top: 30px;
      }
    }

    .number-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      position: relative;
      width: 520px;

      img {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        width: 191px;
      }

      .item:nth-child(2) {
        margin-top: 80px;
        margin-bottom: -50px;
      }

      .item:nth-child(3) {
        margin-bottom: -50px;
      }

      .item:nth-child(4) {
        margin-top: 80px;
      }

      .item {
        width: 248px;
        height: 153px;
        background: #FFFFFF;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
        border-radius: 20px 20px 20px 20px;
        text-align: center;
        z-index: 10;

        h4 {
          font-family: Roboto, Roboto;
          font-weight: bold;
          font-size: 52px;
          color: #252B42;
          margin-top: 20px;
        }

        p {
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 18px;
          color: #7A7A7A;
        }
      }
    }
  }
</style>